var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.loaded)?_c('line-chart',{attrs:{"chartdata":_vm.chartdata,"options":_vm.options}}):_vm._e(),_c('hr'),_c('v-client-table',{attrs:{"data":_vm.tableData,"columns":_vm.columns,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }